import { defineMessages } from "react-intl";

export const pagesListSearchAndFiltersMessages = defineMessages({
  searchPlaceholder: {
    id: "nP8iex",
    defaultMessage: "Search Content",
    description: "search content placeholder",
  },
  publish: {
    id: "j/Oo0B",
    defaultMessage: "Publish",
    description: "bulk actions button label",
  },
  unpublish: {
    id: "ftOPoy",
    defaultMessage: "Unpublish",
    description: "bulk actions button label",
  },
  delete: {
    id: "zfBsje",
    defaultMessage: "Delete content",
    description: "bulk actions button label",
  },
});
